import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TGetAlertBannerData } from './types/alert'

export const alertApi = {
  getAlertBanner: ({ signal }: TSignalConfig) => fetcher.query<TGetAlertBannerData>(`/alert-banner`, { signal }),
}
